import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { AppLayout } from '../components/layouts';

/**
 * @description creates a private route to any route you want the user to be logged in.
 */
const PrivateRoute = ({user, children, path, component, pageTitle, ...rest}) => {

    if(!user) {  return <Redirect to="/auth" /> }
    return (
        <Route
            exact
            path={path}
            render={ component ? component : () => (
                <AppLayout pageTitle={pageTitle}>
                    {children}
                </AppLayout>
            )}/>);

}

const mapStateToProps = ({AuthReducer}) =>({
    user: AuthReducer.user
})

export default connect(mapStateToProps)(PrivateRoute);